import api from "./api";

export async function getSalesAnalytics(
  {
    start_date,
    end_date,
    territory_id,
    comparison,
    comparison_start_date,
    comparison_end_date,
  },
  options = {}
) {
  const params = { start_date, end_date };
  const optionalParams = {
    territory_id,
    comparison,
    comparison_start_date,
    comparison_end_date,
  };

  Object.entries(optionalParams).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      params[key] = value;
    }
  });

  const config = { params };
  if (options.signal) {
    config.signal = options.signal;
  }

  const response = await api.get("/api/accounting/sales_analytics/", config);
  return response.data;
}
